import { Box, Button } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";

import CustomCard from "../../components/CustomCard";
import Loader from "../../components/Loader";
import Spacing from "../../components/Spacing";
import useCurrentUser from "../../hooks/useCurrentUser";
import { brandDocRef } from "../../utils/referencies";
import { applyUpdateTimestamp } from "../../utils/timestamp";
import { useNotify, useRedirect } from "react-admin";
import useDisabledOnLoading from "../../hooks/useDisabledOnLoading";
import ProfileLogo from "./components/ProfileLogo";
import { uploadedLogo } from "./utils/uploadedImages";
import CustomTextField from "./components/CustomTextField";
import { isEmpty } from "ramda";

const StoreProfile = () => {
  const { user } = useCurrentUser();
  const notify = useNotify();
  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<any>({ mode: "onChange" });
  const redirect = useRedirect();

  const [loadingFetching, setLoadingFetching] = useState(false);
  const [fetchedData, setFetchedData] = useState<any>(null);
  const [profileLogo, setProfileLogo] = useState<any>(null);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const { disabledStyles } = useDisabledOnLoading(loadingSubmit);

  const onSubmit: SubmitHandler<any> = async (data) => {
    setLoadingSubmit(true);
    const selectedUploadedLogo = profileLogo ? await uploadedLogo(profileLogo) : fetchedData?.logo;
    let finalData = data;
    if (!data.password) {
      const { password, ...restData } = data;
      finalData = restData;
    }
    try {
      await brandDocRef(user.id!).update(
        applyUpdateTimestamp({
          ...finalData,
          phoneNumber: `+974${data.phoneNumber}`,
          whatsappNumber: `+974${data.phoneNumber}`,
          logo: selectedUploadedLogo,
        })
      );
      notify("Porfile has been updated successfully", "success");
      redirect("/");
      setLoadingSubmit(false);
    } catch (ex: any) {
      console.log(ex.message);
      notify("Error on updating profile", "error");
      setLoadingSubmit(false);
    }
  };

  const fetchData = async () => {
    setLoadingFetching(true);
    try {
      const snapshot = await brandDocRef(user.id!).get();
      if (snapshot.exists) {
        const data = snapshot?.data();
        setFetchedData({
          ...data,
        });
        setLoadingFetching(false);
      }
    } catch (ex: any) {
      console.log(ex.message);
      setLoadingFetching(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Loader loading={loadingFetching}>
      <Box style={disabledStyles}>
        {fetchedData ? (
          <form onSubmit={handleSubmit(onSubmit)}>
            <CustomCard width="50%" title="Details">
              <Spacing>
                <CustomTextField
                  disabled={true}
                  control={control}
                  name="displayName.en"
                  label="Display Name (en)"
                  defaultValue={fetchedData.displayName.en}
                  rules={{
                    required: "Required",
                    maxLength: {
                      value: 50,
                      message: "Must be 32 characters or less",
                    },
                    minLength: {
                      value: 2,
                      message: "Must be 2 characters at least",
                    },
                  }}
                />
                <CustomTextField
                  disabled={true}
                  control={control}
                  name="displayName.ar"
                  label="Display Name (ar)"
                  defaultValue={fetchedData.displayName.ar}
                  rules={{
                    required: "Required",
                    maxLength: {
                      value: 50,
                      message: "Must be 32 characters or less",
                    },
                    minLength: {
                      value: 2,
                      message: "Must be 2 characters at least",
                    },
                  }}
                />
              </Spacing>

              <Spacing>
                <CustomTextField
                  disabled={true}
                  control={control}
                  name="email"
                  label="Email"
                  defaultValue={fetchedData.email}
                  rules={{
                    required: "Required",
                    pattern: {
                      value:
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                      message: "Invalid Email",
                    },
                  }}
                />
                <CustomTextField
                  control={control}
                  name="emailingMail"
                  label="Emailing mail"
                  defaultValue={fetchedData.emailingMail}
                  rules={{
                    required: "Required",
                    pattern: {
                      value:
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                      message: "Invalid Email",
                    },
                  }}
                />
              </Spacing>
              <CustomTextField
                control={control}
                name="password"
                label="Password"
                defaultValue={fetchedData.password}
                type="password"
                rules={{
                  minLength: {
                    value: 8,
                    message: "Must be 8 characters at least",
                  },
                }}
              />
            </CustomCard>
            <ProfileLogo logo={fetchedData.logo} setUploadLogo={(uploadedLogo: any) => setProfileLogo(uploadedLogo)} />

            <Button variant="contained" color="primary" type="submit" disabled={!isEmpty(errors)}>
              Save
            </Button>
          </form>
        ) : null}
      </Box>
    </Loader>
  );
};

export default StoreProfile;
